// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-title[data-v-01129cd6]{color:#000;font-size:21px;font-style:normal;font-weight:400;line-height:normal}.filter-card[data-v-01129cd6]{border-width:0!important}.filter-label[data-v-01129cd6]{color:#000;font-family:Roboto;font-size:12px;font-style:normal;font-weight:400;line-height:normal}.button-layout[data-v-01129cd6]{gap:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
